import { getFssTeamInfo } from "@mirage/service-fss-team-info";
import type { FssTeamInfoSurveyAnswers } from "@mirage/service-fss-team-info/service";
import type { OnboardingSurveyAnswer } from "@mirage/service-onboarding-surveys/service/types";
import Sentry from "@mirage/shared/sentry";
import { useEffect, useState } from "react";

function convertToOnboardingSurveyAnswers(
  fssAnswers: FssTeamInfoSurveyAnswers,
): OnboardingSurveyAnswer[] {
  if (!fssAnswers.surveyAnswers) return [];

  return fssAnswers.surveyAnswers.map(({ surveyQuestionId, surveyAnswer }) => ({
    surveyQuestionId,
    surveyAnswer,
  }));
}

export const useFssTeamInfo = () => {
  const [teamName, setTeamName] = useState<string | null>(null);
  const [teamLogo, setTeamLogo] = useState<string | null>(null);
  const [surveyResponses, setSurveyResponses] = useState<
    OnboardingSurveyAnswer[]
  >([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const doSetFssInfo = async () => {
      try {
        setLoading(true);
        const teamInfo = await getFssTeamInfo();

        if (!teamInfo) {
          setLoading(false);
          return;
        }
        setTeamName(teamInfo.teamName);
        setTeamLogo(teamInfo.teamLogo);
        const surveyResponses: OnboardingSurveyAnswer[] =
          teamInfo.surveyAnswers.flatMap(convertToOnboardingSurveyAnswers);
        setSurveyResponses(surveyResponses);
      } catch (error) {
        Sentry.captureException(error);
      } finally {
        setLoading(false);
      }
    };
    doSetFssInfo();
  }, []);

  return { teamLogo, teamName, surveyResponses, loading };
};
